import { Button, Card, CardContent, CardHeader, Grid, Stack, Typography } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";
import { AppRegistrationIcon } from "@bvhi/ui-icons";
import { useNavigate } from "@tanstack/react-router";

export const RegistrationCard = () => {
  const { t } = useTranslation(["home"]);
  const navigate = useNavigate();

  return (
    <Card>
      <CardHeader subheader={t("home:home.registration.card.sub.title")} title={t("home:home.registration.card.title")} />
      <CardContent>
        <Grid container spacing={3}>
          <Grid md={6} xs={12}>
            <Stack spacing={1}>
              <Typography sx={{ fontWeight: 600, minHeight: 40 }}>{t("home:home.registration.card.body.1")}</Typography>
              <Button
                onClick={() => window.open("https://bvhi.org/hidatasync/code-anfordern/", "_blank", "noreferrer")}
                startIcon={<AppRegistrationIcon />}
                sx={{ maxWidth: 350 }}
                type="button"
              >
                {t("home:home.registration.card.action.1")}
              </Button>
            </Stack>
          </Grid>
          <Grid md={6} xs={12}>
            <Stack spacing={1}>
              <Typography sx={{ fontWeight: 600, minHeight: 40 }}>{t("home:home.registration.card.body.2")}</Typography>
              <Button
                onClick={() => void navigate({ to: "/registration" })}
                startIcon={<AppRegistrationIcon />}
                sx={{ maxWidth: 175 }}
                type="button"
              >
                {t("home:home.registration.card.action.2")}
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
